<template>
  <div class="page_bg">
    <div class="container">
      <div class="row">
        <div class="main_inventory auto_height">
          <loading v-model:active="isLoading" />
          <div class="position-relative img_main">
            <!-- <img src="/images/inventory-layer.png" class="img-fluid bg_img" /> -->
            <div class="top-label">
              <div class="inventory-label">
                <img
                  src="/images/inventory-label.png"
                  class="img-fluid"
                  alt=""
                />
                <h3>{{ selectedType }}</h3>
              </div>
            </div>

            <div class="top_btns">
              <a
                href="#"
                class="inventory_btn"
                @click.prevent="changeType('Craft')"
              >
                <img src="/images/crafting.png" class="img-fluid" alt="" />
                <h4>Craft</h4>
              </a>

              <a
                href="#"
                class="inventory_btn mx-lg-3"
                @click.prevent="changeType('Upgrade')"
              >
                <img src="/images/upgrade.png" alt="" class="img-fluid" />
                <h4>Upgrade</h4>
              </a>
              <a
                href="#"
                class="inventory_btn"
                @click.prevent="configModal = true"
                v-if="admin"
              >
                <img src="/images/cog.png" alt="" class="img-fluid" />
                <h4>Config</h4>
              </a>
              <Config
                v-if="configModal"
                v-on:w-modal-hide-click="configModal = false"
              />
            </div>
            <div class="row">
              <div class="col-lg-6 right_border">
                <div class="inventory-card scrollbar">
                  <loading v-model:active="isLoading" />
                  <div v-if="selectedType == 'Craft'">
                    <div class="row">
                      <div class="col-4 col-lg-4 col-md-4">
                        <div class="md-card">
                          <div
                            class="wood-card-frame position-relative wallet-dyn"
                          >
                            <a
                              href="#"
                              @click.prevent="
                                setWeapon(dynamite, '/images/nfts/609612.gif')
                              "
                            >
                              <ImgBlock
                                :img="'/images/nfts/609612.gif'"
                                :link="false"
                                :defaultLink="'/images/nfts/609612.gif'"
                              />
                            </a>
                          </div>
                          <h4 class="text-white" v-if="admin">609612</h4>
                        </div>
                      </div>
                      <div
                        class="col-4 col-lg-4 col-md-4"
                        v-for="(item, index) in info"
                        :key="index"
                      >
                        <div class="md-card">
                          <div
                            class="wood-card-frame position-relative mb-3 craft_images"
                          >
                            <a
                              href="#"
                              @click.prevent="
                                setWeapon(item, item.immutable_data.img)
                              "
                            >
                              <VideoBlock :link="item.template_id" />
                            </a>
                          </div>
                          <h4 class="text-white" v-if="admin">
                            {{ item.template_id }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div
                      class="col-4 col-lg-4 col-md-4"
                      v-for="(item, index) in inventory"
                      :key="index"
                    >
                      <div class="md-card">
                        <div class="wood-card-frame position-relative">
                          <a
                            href="#"
                            @click.prevent="
                              setChar(
                                item,
                                `/images/nfts/${item.value.templ_id}`
                              )
                            "
                          >
                            <VideoBlock :link="item.value.templ_id" />
                          </a>
                        </div>
                        <h5 class="text-white">
                          Level: {{ item.value.level }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div v-if="selectedCard">
                  <div
                    class="crafting-card mt-3"
                    v-if="selectedType == 'Craft'"
                  >
                    <span class="ml-2 text-default" v-if="selectedWeapon">{{
                      selectedCard.immutable_data.name
                    }}</span>
                    <div
                      class="crafting-frame wood-card-frame position-relative singleImg_prev"
                      :class="
                        selectedCard.template_id == 609612 ? 'dyn-block' : ''
                      "
                    >
                      <a href="#">
                        <ImgBlock
                          v-if="isWeaponLoading"
                          :img="`/images/nfts/${selectedCard.template_id}.gif`"
                          :link="false"
                          :defaultLink="`/images/nfts/${selectedCard.template_id}.gif`"
                        />
                        <VideoBlock v-else :link="selectedCard.template_id" />
                      </a>
                    </div>
                  </div>
                  <div class="crafting-card mt-3" v-else>
                    <span class="ml-2 text-default" v-if="selectedWeapon">{{
                      selectedCard.name
                    }}</span>
                    <div
                      class="crafting-frame wood-card-frame position-relative singleImg_prev"
                    >
                      <a href="#">
                        <ImgBlock
                          v-if="isWeaponLoading"
                          :img="`/images/nfts/${selectedCard.value.templ_id}.gif`"
                          :link="false"
                          :defaultLink="`/images/nfts/${selectedCard.value.templ_id}.gif`"
                        />
                        <VideoBlock
                          v-else
                          :link="selectedCard.value.templ_id"
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    class="crafting-tool-wrapper scrollbar"
                    v-if="selectedConfig"
                  >
                    <div
                      class="row align-items-center"
                      v-if="selectedType == 'Craft'"
                    >
                      <craft-config
                        :selectedConfig="selectedConfig"
                        :gameItemsObj="gameItems"
                      />
                    </div>
                    <div
                      class="row align-items-center justify-content-center"
                      v-else
                    >
                      <upgrade-config :selectedConfig="selectedConfig" />
                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            type="text"
                            placeholder="Enter level"
                            v-model="level"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="crafting-tool-wrapper" v-else>
                    <div class="row">
                      <div class="col-md-12">
                        <h3 class="text-default">
                          Not available for crafting, or select another card
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div
                    class="bottom_btn text-center"
                    :class="selectedType == 'Craft' ? 'craft-btn' : ''"
                  >
                    <a href="#" class="stake_btn" @click="result(schema)">
                      <img
                        src="/images/polygon-button-2.png"
                        class="img-fluid"
                        alt=""
                      />
                      <h5>{{ selectedType }}</h5>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../components/Modal/Config";
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VideoBlock from "../components/VideoBlock.vue";
import ImgBlock from "../components/ImgBlock.vue";
import { mapGetters } from "vuex";
import CraftConfig from "../components/CraftConfig.vue";
import UpgradeConfig from "../components/UpgradeConfig.vue";
export default {
  name: "Crafting",
  components: {
    Loading,
    VideoBlock,
    ImgBlock,
    Config,
    CraftConfig,
    UpgradeConfig,
  },
  computed: {
    ...mapGetters(["myChars", "myGuns", "inventory"]),
  },

  showModal: true,
  data() {
    return {
      info: null,
      configModal: false,
      isLoading: false,
      level: "",
      isWeaponLoading: false,
      isImageLoaded: false,
      schema: "guns",
      imageFailed: [],
      dynamite: {
        template_id: 609612,
        name: "Dynamite",
        immutable_data: { name: "Dynamite" },
      },
      configuration: [],
      selectedConfig: null,
      selectedCard: null,
      selectedType: "Craft",
      selectedWeapon: "",
      admin: "",
      gameItems: "",
    };
  },
  mounted() {
    this.init(this.schema);
    ApiService.getConfig((response) => {
      this.configuration = response;
    });
    this.admin = localStorage.getItem("wax_user");
    if (this.admin == process.env.VUE_APP_CONTRACT) {
      this.admin = true;
    } else {
      this.admin = false;
    }
    this.gameItems = ApiService.gameItemList();
  },
  methods: {
    changeType(type) {
      this.selectedType = type;
      this.selectedWeapon = "";
      this.selectedCard = null;
      if (type == "Craft") {
        this.init("guns");
      } else {
        this.init("characters");
      }
    },
    setWeapon(item, url) {
      this.isWeaponLoading = true;
      this.selectedCard = item;
      this.selectedWeapon = url;

      const row = this.configuration.filter((i) => {
        if (this.selectedType == "Craft") {
          return i.asset_t == item.template_id;
        } else {
          return i.asset_t == item.template.template_id;
        }
      });
      if (row.length) {
        this.selectedConfig = row[0];
      } else {
        this.selectedConfig = [];
      }
      setTimeout(() => {
        this.isWeaponLoading = false;
      }, 100);
    },
    setChar(item, url) {
      this.isWeaponLoading = true;
      this.selectedCard = item;
      this.selectedWeapon = url;

      const row = this.configuration.filter((i) => {
        return i.asset_t == item.value.templ_id;
      });
      if (row.length) {
        this.selectedConfig = row[0];
      } else {
        this.selectedConfig = [];
      }
      setTimeout(() => {
        this.isWeaponLoading = false;
      }, 100);
    },

    hideModal(e) {
      this.$emit("modal-hide", e);
    },
    loaded() {
      this.isImageLoaded = true;
    },
    async result(schema) {
      if (schema) {
        const data = {
          contract: process.env.VUE_APP_CONTRACT,
          action: "craft",
          data: {
            account: localStorage.getItem("wax_user"),
            asset_t: this.selectedCard.template_id,
          },
        };
        if (schema == "characters") {
          data.action = "char.upgrade";
          data.data = {
            account: localStorage.getItem("wax_user"),
            asset_id: this.selectedCard.key,
            level: this.level,
            asset_t: this.selectedCard.value.templ_id,
          };
        }
        await ApiService.transaction(
          data,
          (res) => {
            if (res.processed) {
              ApiService.successMsg();
              this.init(this.schema, true);
              this.selectedStakeCards = [];
              ApiService.getHeaderContents();
            }
          },
          (error) => {
            ApiService.errorMsg(error);
          }
        );
      }
    },
    getImgUrl(hash) {
      return ApiService.getImgUrl(hash);
    },
    replaceByDefault(i) {
      this.imageFailed[i] = true;
    },

    init(schema, refresh = false) {
      if (schema == "guns" && this.myGuns && !refresh) {
        this.info = this.myGuns;
      } else if (schema == "characters" && this.myChars && !refresh) {
        this.info = this.myChars;
      } else {
        this.isLoading = true;
        const responseCallback = (response) => {
          if (response) {
            this.info = response;
            if (schema == "guns") {
              this.$store.commit("addGuns", this.info);
            } else {
              this.info.map(async (item, i) => {
                this.info[i].immutable_data = item.data;
              });
              this.$store.commit("addChars", this.info);
            }
          } else {
            this.info = [];
          }
          this.isLoading = false;
        };
        if (schema == "guns") {
          ApiService.getNftsBySchema(schema, responseCallback);
        } else {
          ApiService.getInventory((res) => {
            this.info = res.filter((i) => i.value.schema == "characters");
            this.info.map(async (item, i) => {
              this.info[i].value.locked = ApiService.isExpired(
                item.value.lock_end
              );
            });
            this.$store.commit("addInventory", this.info);
            this.isLoading = false;
          });
        }
      }
      ApiService.getConfig((response) => {
        this.configuration = response;
      });
      this.schema = schema;
    },
  },
};
</script>
<style scoped>
.auto_height {
  height: auto;
  width: 100%;
}
.wallet-dyn img {
  margin-top: 14px !important;
  width: 100px !important;
}
.wallet-dyn {
  width: 150px !important;
  padding: 18px 19px !important;
}
.img_main {
  background: url("/images/inventory-layer.png") no-repeat center center;
  background-size: 100% 100%;
  /* height: 100%; */
  width: 95%;
  margin: 0 auto;
  padding: 0 20px 0 20px;
}

.craft-btn {
  top: 40px;
}
.inventory-card {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 45px;
  margin-bottom: 34px;
  padding-top: 20px;
}
.dyn-block {
  height: 162px;
  width: 124px;
}
/* .crafting_section .bottom_btn{
  top: 50px;
} */

/* .uncrated_section {
  width: 42%;
  position: absolute;
  top: 16px;
  left: 39px;
  overflow: hidden;
  z-index: 1;
} */

.crafting-frame {
  margin: 5px auto 0 auto;
  padding: 14px 8px;
  position: relative;
}
.crafting-frame img {
  aspect-ratio: 3/2;
}
.crafting-frame h6 {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.wood-card-frame {
  padding: 14px 9px;
}
/* .crafting_section {
  width: 42%;
  position: absolute;
  top: 16px;
  right: 39px;
  z-index: 1;
} */

/* .crafting_section .img-frame::after {
  content: "";
  background: rgba(0, 0, 0, 0.1);
  display: block;
  width: 77%;
  height: 82%;
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 23px;
} */
.right_border:before {
  content: "";
  background-image: url("/images/stick.png");
  width: 34px;
  height: 100%;
  position: absolute;
  right: -15px;
  background-position: 100% 100%;
  background-size: contain;
  top: 4px;
}

.crafting-tool-wrapper {
  padding: 4px 46px;
  height: 180px;
  overflow-y: scroll;
}
.crafting-tool_group {
  margin-top: 5px;
}

.crafting-tool_group span {
  display: inline-block;
  color: #fff;
}
.crafting-tool_group .crafting-img {
  width: 80px;
  margin: auto;
}
.crafting-tool_group .crafting-img img {
  aspect-ratio: 3/2;
  object-fit: contain;
}
@media (max-width: 992px) {
  .right_border:before {
    display: none;
  }
}
@media (max-width: 768px) {
  .crafting-tool-wrapper {
    padding: 0px;
    height: 340px;
  }
  .wood-card-frame {
    padding: 14px 0px !important;
  }
  .wallet-dyn {
    width: 100% !important;
    padding: 14px 0px !important;
  }
  .craft_images .card_images {
    width: 100%;
  }
  .inventory-card {
    margin-top: 130px;
  }
  .dyn-block {
    height: 200px;
  }
}
</style>
